/* eslint-disable max-len */
import { newThemeOptions } from 'src/theme/theme';

export interface VaultLogoProps {
  color: 'N0' | 'N800' | 'T300';
  size: 'xsmall' | 'small' | 'default' | 'large';
  altText?: string;
}

export const VaultLogo = (props: VaultLogoProps) => {
  let logoSize;
  let logoColor;

  switch (props.size) {
    case 'xsmall':
      logoSize = '30';
      break;
    case 'small':
      logoSize = '40';
      break;
    case 'large':
      logoSize = '80';
      break;
    default:
      logoSize = '50';
      break;
  }

  switch (props.color) {
    case 'N0':
      logoColor = newThemeOptions.newPalette.neutral.N0;
      break;
    case 'N800':
      logoColor = newThemeOptions.newPalette.neutral.N800;
      break;
    default:
      logoColor = newThemeOptions.newPalette.turquoise.T300;
  }
  return (
    <svg
      height={logoSize}
      viewBox="0 0 126 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="logo-title"
    >
      <title id="logo-title">{props.altText ?? 'Logo'}</title>
      <path
        d="M22.2404 10.5674L14.8672 33.0245L7.44366 10.5674H0L0.163514 11.0324L11.2724 39.9999H18.5073L29.7797 10.5674H22.2404Z"
        fill={logoColor}
      />
      <path
        d="M41.0042 10.1052C37.9654 10.06 34.9517 10.5929 32.099 11.5883V17.3119C34.836 16.2687 37.7113 15.7584 40.6344 15.8288C44.7399 15.8288 46.7801 17.6588 46.7801 21.3438C45.0644 21.0899 43.3714 20.9492 41.6784 20.9492C39.7062 20.9265 37.7591 21.1804 35.88 21.7133C34.5341 22.0602 33.2813 22.6861 32.1694 23.5206C31.3821 24.1918 30.7079 25.0263 30.1972 25.9539C29.8274 26.6728 29.5004 27.4369 29.3168 28.2489C29.201 28.8521 29.1306 29.4529 29.1306 30.0562C29.0853 32.7433 30.1972 35.3173 32.1468 37.102C34.1643 39.0476 37.4799 39.9977 41.5853 39.9977C45.6908 39.9977 48.7976 39.0476 50.7924 37.1246C52.7169 35.3399 53.8086 32.8614 53.7835 30.2422V22.4322C53.7835 18.4229 52.6691 15.3864 50.4906 13.2775C48.2869 11.1685 45.1323 10.1027 41.0042 10.1027V10.1052ZM46.7801 29.5032C46.7574 32.4467 45.0166 33.9071 41.5627 33.9071C38.1088 33.9071 36.1114 32.3537 36.1114 29.2493C36.1114 26.7231 38.2673 25.4713 42.6293 25.4713C44.0204 25.5165 45.4116 25.6573 46.7801 25.8433V29.5057V29.5032Z"
        fill={logoColor}
      />
      <path
        d="M76.5344 27.1321C76.5344 29.1028 76.0011 30.6538 74.9345 31.7899C72.361 34.0372 68.5575 34.0372 65.9815 31.7899C64.9149 30.6764 64.3815 29.1255 64.3815 27.1321V10.562H57.4008V26.4132C57.4008 30.6764 58.5605 33.9919 60.832 36.4025C66.3286 41.1986 74.5622 41.1986 80.0588 36.4025C82.3555 33.9919 83.5378 30.6311 83.5378 26.4132V10.562H76.5344V27.1321Z"
        fill={logoColor}
      />
      <path d="M94.1159 0H87.1578V40H94.1159V0Z" fill={logoColor} />
      <path
        d="M125.926 33.6501H118.945V39.9997H125.926V33.6501Z"
        fill={logoColor}
      />
      <path
        d="M112.196 33.9645C109.667 33.9645 108.415 31.8102 108.44 27.4515C108.462 27.1977 108.44 3.68481 108.44 3.68481H101.482V10.5346H96.5208V16.5146H101.461V30.4202C101.298 32.9917 102.181 35.5179 103.919 37.4409C105.288 38.7631 107.051 39.6428 108.93 39.8967C109.511 39.9897 110.113 40.0123 110.716 39.9897H110.88C112.409 40.0123 113.919 39.7107 115.332 39.1326V33.3612C114.661 33.6402 113.987 33.8011 113.222 33.8941C112.897 33.9393 112.573 33.9645 112.201 33.9645H112.196Z"
        fill={logoColor}
      />
      <text
        fill={logoColor}
        fontFamily="Sans"
        fontSize="10"
        x="42.5"
        y="49"
        id="text6"
      >
        <tspan
          id="tspan6"
          x="42.5"
          y="49"
          fontSize="10"
          fontFamily="Rubik,Sans"
          strokeWidth={1}
          dx="0 0 0 0 0 0 0 0 0 0 0"
        >
          a Diligent brand
        </tspan>
      </text>
    </svg>
  );
};
